import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Opening Day
import HomeOpeningDay from "./views/openingDay/Home";
import ConfirmationOpeningDay from "./views/openingDay/Step10_Confirmation";

// Day of Open Doors
import HomeDayOfOpenDoors from "./views/dayOfOpenDoors/Home";
import TicketDayOfOpenDoors from "./views/dayOfOpenDoors/Step10_Ticket";
import ParticipantDayOfOpenDoors from "./views/dayOfOpenDoors/Step20_Participant";
import ConfirmationDayOfOpenDoors from "./views/dayOfOpenDoors/Step30_Confirmation";

// Fallback page
import PageNotFound from "./views/components/PageNotFound";

import "./css/style.css";
import "./css/footer.css";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="*" element={<PageNotFound />} />

                {/* Opening Day */}
                <Route path="/:language/offizielle-eroeffnung" element={<HomeOpeningDay />} />
                <Route path="/:language/offizielle-eroeffnung/confirmation/:orderId" element={<ConfirmationOpeningDay />} />  

                {/* Day of Open Doors */}
                <Route path="/:language/tag-der-offenen-tuer" element={<HomeDayOfOpenDoors />} />
                <Route path="/:language/tag-der-offenen-tuer/ticket" element={<TicketDayOfOpenDoors />} />
                <Route path="/:language/tag-der-offenen-tuer/participant" element={<ParticipantDayOfOpenDoors />} />
                <Route path="/:language/tag-der-offenen-tuer/confirmation/:orderId" element={<ConfirmationDayOfOpenDoors />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
